import { render, staticRenderFns } from "./EntitiesDialog.vue?vue&type=template&id=c730e470&scoped=true&"
import script from "./EntitiesDialog.vue?vue&type=script&lang=js&"
export * from "./EntitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c730e470",
  null
  
)

export default component.exports